import { IMG } from "../data/site";
import { PageHero, Section, Overline, EnquiryForm } from "../components/site/bits";
import { Reveal, Stagger, StaggerItem } from "../components/site/motion";
import { Check } from "lucide-react";

const FOR = ["Local Authorities", "Home Office Providers", "Charities", "Support Organisations", "Self Referral"];
const CRITERIA = [
  "Aged 18 or over", "Refugee, migrant or vulnerable adult status",
  "Requires supported accommodation with care or supervision", "Willing to engage with a personalised support plan",
  "Referred by an authorised partner organisation",
];

export default function Referrals() {
  return (
    <>
      <PageHero overline="Referrals" lines={["Make a referral,", "in minutes."]} image={IMG.officeHigh5}
        intro="A simple, safe referral process for local authorities, Home Office providers, charities and support organisations. Our team responds within two working days." />

      <Section>
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Overline>Who can refer</Overline>
            <Stagger className="mt-8 space-y-3">
              {FOR.map((f) => (
                <StaggerItem key={f} className="rounded-xl border border-brand-dark/10 bg-brand-surface px-6 py-4 font-serif text-lg text-brand-dark">{f}</StaggerItem>
              ))}
            </Stagger>
            <Overline className="mt-12 block">Referral criteria</Overline>
            <ul className="mt-6 space-y-3">
              {CRITERIA.map((c) => <li key={c} className="flex items-start gap-3 text-brand-slate"><Check className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" />{c}</li>)}
            </ul>
            <div className="mt-10 rounded-2xl bg-brand-dark p-8 text-brand-main">
              <p className="text-sm text-brand-main/70">Prefer to talk first?</p>
              <p className="mt-2 font-serif text-2xl">Call our referrals team</p>
              <p className="mt-1 text-brand-leaf">024 7699 5724</p>
            </div>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal>
              <div className="rounded-3xl border border-brand-dark/10 bg-brand-surface p-8 md:p-12">
                <h2 className="font-serif text-3xl text-brand-dark">Referral form</h2>
                <p className="mt-2 text-sm text-brand-slate">Complete the form below and our team will be in touch.</p>
                <div className="mt-8">
                  <EnquiryForm kind="referral" testid="referral-form" submitLabel="Submit referral"
                    note="By submitting you confirm you have consent to share the referred person's details."
                    fields={[
                      { name: "name", label: "Full name", required: true, placeholder: "Client full name" },
                      { name: "dob", label: "Date of birth", type: "date", required: true },
                      { name: "phone", label: "Telephone number", type: "tel", required: true, placeholder: "07000 000000" },
                      { name: "email", label: "Email address", type: "email", placeholder: "client@email.com" },
                      { name: "arrival_uk", label: "When did the client first arrive in the UK?", type: "date" },
                      { name: "current_address", label: "Client's current address", required: true, placeholder: "Current address" },
                      { name: "homeless", label: "Is the client currently homeless?", type: "select", required: true, placeholder: "Select", options: ["Yes", "No"] },
                      { name: "gender", label: "Gender", type: "select", placeholder: "Select gender", options: ["Male", "Female", "Non-binary", "Transgender", "Prefer not to say", "Other"] },
                      { name: "religion", label: "Religion", type: "select", placeholder: "Select religion", options: ["Islam", "Christianity", "Buddhism", "Judaism", "Hindu", "Other"] },
                      { name: "ethnic_group", label: "Ethnic group", placeholder: "e.g. African, Arab, South Asian" },
                      { name: "preferred_language", label: "Preferred language", placeholder: "e.g. Arabic, Farsi, Pashto" },
                      { name: "employment_status", label: "Employment status", type: "select", placeholder: "Select status", options: ["Employed", "Unemployed"] },
                      { name: "medical_condition", label: "Client's medical condition", type: "textarea", placeholder: "Any relevant medical conditions" },
                      { name: "organisation", label: "Referral agency", placeholder: "Agency / organisation name" },
                      { name: "agency_phone", label: "Referral agency's telephone number", type: "tel", placeholder: "024 7600 0000" },
                      { name: "agency_email", label: "Referral agency's email address", type: "email", placeholder: "agency@org.uk" },
                      { name: "message", label: "Additional information", type: "textarea", placeholder: "Anything else we should know" },
                      { name: "referral_date", label: "Date of referral", type: "date", required: true },
                    ]} />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </Section>
    </>
  );
}
